export const PumpkinMark = ({ size = 40, glow = true }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 100"
    fill="none"
    aria-hidden="true"
    style={
      glow ? { filter: "drop-shadow(0 0 12px rgba(255,107,0,0.6))" } : undefined
    }
  >
    <polygon points="50,6 57,26 43,26" fill="#10B981" />
    <circle cx="50" cy="56" r="38" fill="#FF6B00" />
    <path d="M29 48 L43 48 L36 36 Z M71 48 L57 48 L64 36 Z" fill="#0A0812" />
    <path
      d="M28 66 Q50 84 72 66 L65 69 L60 62 L55 70 L50 63 L45 70 L40 62 L35 69 Z"
      fill="#0A0812"
    />
  </svg>
);
